import type { NextPage } from "next";

import { ColorGradient } from "@/types/styles/designSystemEnum";

interface Props {
  height?: string;
  width?: string;
  color?: string;
  startColor?: string;
  stopColor?: string;
  isGradient?: boolean;
}

const LocationIcon: NextPage<Props> = ({
  width = "16",
  height = "16",
  color = "#511010",
  startColor = ColorGradient.RED_0,
  stopColor = ColorGradient.RED_100,
  isGradient = false,
}) => {
  return !isGradient ? (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00002 9.72247C6.70052 9.72247 5.64329 8.66523 5.64329 7.36574C5.64329 6.06592 6.70052 5.00868 8.00002 5.00868C9.29984 5.00868 10.3571 6.06592 10.3571 7.36574C10.3571 8.66523 9.29984 9.72247 8.00002 9.72247ZM8.00002 6.01983C7.2581 6.01983 6.65444 6.6235 6.65444 7.36573C6.65444 8.10765 7.25811 8.71131 8.00002 8.71131C8.74226 8.71131 9.34592 8.10764 9.34592 7.36573C9.34592 6.6235 8.74226 6.01983 8.00002 6.01983Z"
        fill={color}
      />
      <path
        d="M8.00002 15.1663C7.90292 15.1663 7.80549 15.1384 7.7209 15.0824C7.50629 14.9402 2.46729 11.5562 2.46729 7.36574C2.46729 4.31482 4.9491 1.83301 8.00002 1.83301C11.0509 1.83301 13.5331 4.31482 13.5331 7.36574C13.5331 11.5562 8.49375 14.9402 8.27914 15.0824C8.19455 15.1384 8.09712 15.1663 8.00002 15.1663ZM8.00002 2.84417C5.50668 2.84417 3.47844 4.87241 3.47844 7.36574C3.47844 10.4924 6.97438 13.2882 8.00002 14.0413C9.02599 13.2882 12.5219 10.4924 12.5219 7.36574C12.5219 4.87241 10.4934 2.84417 8.00002 2.84417Z"
        fill={color}
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12.0003 14.3342C10.051 14.3342 8.46517 12.7483 8.46517 10.7991C8.46517 8.84937 10.051 7.26351 12.0003 7.26351C13.95 7.26351 15.5359 8.84937 15.5359 10.7991C15.5359 12.7483 13.95 14.3342 12.0003 14.3342ZM12.0003 8.78023C10.8874 8.78023 9.98191 9.68573 9.98191 10.7991C9.98191 11.912 10.8874 12.8175 12.0003 12.8175C13.1136 12.8175 14.0191 11.912 14.0191 10.7991C14.0191 9.68573 13.1136 8.78023 12.0003 8.78023Z"
        fill="url(#paint0_linear_7817_276813)"
      />
      <path
        d="M12.0003 22.5C11.8546 22.5 11.7085 22.458 11.5816 22.3741C11.2597 22.1608 3.70117 17.0848 3.70117 10.7991C3.70117 6.22272 7.42389 2.5 12.0003 2.5C16.5767 2.5 20.2999 6.22272 20.2999 10.7991C20.2999 17.0848 12.7409 22.1608 12.419 22.3741C12.2921 22.458 12.1459 22.5 12.0003 22.5ZM12.0003 4.01674C8.26027 4.01674 5.21791 7.0591 5.21791 10.7991C5.21791 15.489 10.4618 19.6828 12.0003 20.8124C13.5392 19.6828 18.7831 15.489 18.7831 10.7991C18.7831 7.0591 15.7403 4.01674 12.0003 4.01674Z"
        fill="url(#paint1_linear_7817_276813)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7817_276813"
          x1="3.70117"
          y1="14.3478"
          x2="20.2999"
          y2="14.3478"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={startColor} />
          <stop offset="1" stopColor={stopColor} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7817_276813"
          x1="3.70117"
          y1="14.3478"
          x2="20.2999"
          y2="14.3478"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={startColor} />
          <stop offset="1" stopColor={stopColor} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LocationIcon;
